import $ from 'jquery'
import {frame} from '../utilities'

const clsReady = 'is-ready'

const $window = $(window)
let viewportHeight = $window.height()

$window.on('resize', e => viewportHeight = $window.height())

function ready()
{
	const $this = $(this)
	const src = $this.data('image') || $this.data('src') || $this.prop('src')
	const img = new Image()

	const isImg = $this.is('img')
	const isBg = !isImg && $this.data('image')

	img.onload = function()
	{
		if(isImg)
		{
			$this.prop('src', src)
		}
		else if(isBg)
		{
			$this.css('background-image', `url(${src})`)
		}

		$this.addClass(clsReady)
	}

	img.src = src;
}

export default function(context = document.body)
{
	const $context = $(context)
	let counter = 0

	$context.find('img:not([data-src])').each(ready)
	$context.find('[data-image], img[data-src]').each(function()
	{
		const $element = $(this)
		const ns = 'lazy' + (counter++)
		const isImg = $element.is('img')
		const isBg = !isImg && $element.data('image')

		if(isImg)
		{
			$element.attr('src', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==')
		}
		else if(isBg)
		{
			$element.css('background-image', 'none')
		}

		let height
		let offset

		function setup()
		{
			height = $element.outerHeight()
			offset = $element.offset()

			check()
		}

		function check()
		{
			if(offset.top < $window.scrollTop() + viewportHeight)
			{
				ready.call($element)
				$window.off(`.${ns}`)
			}
		}

		setup()

		$window.on(`load.${ns} resize.${ns}`, e => frame(setup))
		$window.on(`scroll.${ns}`, e => frame(check))
	})
}



/** WEBPACK FOOTER **
 ** ./source/scripts/components/image.js
 **/